export const PAYROLL_URL_PARAMS = {
  generate: "user_id",
};

export const normalizePayrollApplicantIds = (applicantIds) =>
  Array.from(
    new Set(
      (applicantIds || [])
        .map((id) => (id === null || id === undefined ? "" : String(id).trim()))
        .filter(Boolean),
    ),
  );

export const parsePayrollGenerateIds = (value) => {
  if (!value) return [];

  return normalizePayrollApplicantIds(value.split(","));
};

export const serializePayrollGenerateIds = (applicantIds) =>
  normalizePayrollApplicantIds(applicantIds).join(",");

export const haveSamePayrollApplicantIds = (left = [], right = []) => {
  const normalizedLeft = normalizePayrollApplicantIds(left);
  const normalizedRight = normalizePayrollApplicantIds(right);

  if (normalizedLeft.length !== normalizedRight.length) {
    return false;
  }

  const leftSet = new Set(normalizedLeft);
  return normalizedRight.every((id) => leftSet.has(id));
};
